export default __webpack_public_path__ + "static/media/20s_bg_desktop@3x.d619cf81.jpg";